import { render, staticRenderFns } from "./SubscriptionNotification.vue?vue&type=template&id=1aad7b90"
import script from "./SubscriptionNotification.vue?vue&type=script&lang=js"
export * from "./SubscriptionNotification.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionNotification.vue?vue&type=style&index=0&id=1aad7b90&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/www-root/data/www/view.sessiondesign.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aad7b90')) {
      api.createRecord('1aad7b90', component.options)
    } else {
      api.reload('1aad7b90', component.options)
    }
    module.hot.accept("./SubscriptionNotification.vue?vue&type=template&id=1aad7b90", function () {
      api.rerender('1aad7b90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/front/shared/views/layouts/partials/SubscriptionNotification.vue"
export default component.exports